export default __webpack_public_path__ + "static/media/6.1ce82949.png";